import { Icon, Text } from '@driftt/dds'
import { faSparkles } from '@driftt/dds.icons/solid/faSparkles'
import React, { ReactElement } from 'react'

import {
  userHasAIPlaybooks,
  userHasBionicChatbots,
  userHasChatAgent,
  userHasChatPlaybooks,
  userHasContentRecommendations,
  userHasContentVariables,
  userHasEmailPlaybooks,
  userHasFastlanePlaybooks,
  userHasGlobalResponses,
  userHasLeadQual,
  userHasMeetingsPlaybooks,
  userHasReusableBlocksV2,
} from 'utils/access'

interface SubNavNode {
  label: string | ReactElement
  path?: string
  hide?: boolean
  exact?: boolean
  external?: boolean
  expanded?: boolean
  nodes?: SubNavNode[]
  'data-ocweb-id'?: string
}

export const getSubNavNodes = (): SubNavNode[] => {
  const hasFastlaneAccess = userHasFastlanePlaybooks()
  const chatbotsList = [
    {
      label: 'Chat agent',
      path: '/chat-agent',
      hide: !userHasChatAgent(),
      exact: true,
      className: {
        'tc-subnav-link--active': window.location.pathname
          .split('/')
          .includes('chat-agent'),
      },
    },
    {
      label: 'Playbooks',
      path: '/list/chat',
      hide: !userHasChatPlaybooks(),
      exact: false,
    },
  ]

  const playbooksList = [
    {
      label: 'Chat playbooks',
      path: '/list/chat',
      hide: !userHasChatPlaybooks(),
      exact: true,
    },
    {
      label: 'Fastlane playbooks',
      path: '/list/fastlane',
      hide: !hasFastlaneAccess,
      exact: true,
    },
    {
      label: 'Email playbooks',
      path: '/list/email',
      hide: !userHasEmailPlaybooks(),
      exact: true,
    },
    {
      label: 'Meeting playbooks',
      path: '/list/meetings',
      hide: !userHasMeetingsPlaybooks(),
      exact: true,
      'data-ocweb-id': 'meeting-playbooks-link',
    },
  ]
  const needsToWrap =
    userHasAIPlaybooks() ||
    userHasGlobalResponses() ||
    userHasReusableBlocksV2() ||
    userHasContentRecommendations()

  return [
    ...(userHasChatAgent() && needsToWrap
      ? [
          {
            label: 'CONFIGURE',
            hide: false,
            exact: false,
            external: false,
            expanded: true,
            nodes: chatbotsList,
          },
        ]
      : []),
    ...(!userHasChatAgent()
      ? needsToWrap
        ? [
            {
              label: 'PLAYBOOKS',
              hide: false,
              exact: false,
              external: false,
              expanded: true,
              nodes: playbooksList,
            },
          ]
        : playbooksList
      : []),
    {
      label: 'Library',
      hide:
        !userHasBionicChatbots() &&
        !userHasAIPlaybooks() &&
        !userHasGlobalResponses() &&
        !userHasReusableBlocksV2(),
      exact: false,
      external: false,
      expanded: true,
      nodes: [
        {
          label: (
            <Text>
              <Icon
                icon={faSparkles}
                size="extra-small"
                css={{ verticalAlign: 'baseline', marginRight: '32px' }}
              />
              {`Scenarios`}
            </Text>
          ),
          path: '/ai-scenarios',
          hide: !userHasBionicChatbots(),
          exact: true,
        },
        {
          label: (
            <Text>
              <Icon
                icon={faSparkles}
                size="extra-small"
                css={{ verticalAlign: 'baseline', marginRight: '32px' }}
              />
              Guardrails
            </Text>
          ),
          path: '/ai-guardrails',
          hide: !userHasBionicChatbots(),
          exact: true,
        },
        {
          label: (
            <Text>
              <Icon
                icon={faSparkles}
                size="extra-small"
                css={{ verticalAlign: 'baseline', marginRight: '32px' }}
              />
              Qualification rules
            </Text>
          ),
          path: '/admin/aiconfiguration',
          hide: !userHasLeadQual(),
          exact: true,
          expanded: true,
        },
        {
          label: 'AI topics',
          path: '/playbooks/ai-topics',
          hide: !userHasAIPlaybooks(),
          exact: false,
          external: true,
        },
        {
          label: 'Reusable blocks',
          path: '/blocks/list',
          hide: !userHasReusableBlocksV2(),
          exact: true,
        },
        {
          label: 'Content variables',
          path: '/global/variables',
          hide: !userHasContentVariables(),
          exact: true,
        },
        {
          label: 'Global bot responses',
          path: '/playbook-settings/responses',
          hide: !userHasGlobalResponses(),
          exact: true,
          external: true,
        },
      ],
    },
    {
      label: 'AI testing',
      hide: !userHasBionicChatbots(),
      exact: false,
      external: false,
      expanded: true,
      nodes: [
        {
          label: (
            <Text>
              <Icon
                icon={faSparkles}
                size="extra-small"
                css={{ verticalAlign: 'baseline', marginRight: '32px' }}
              />
              {`AI Responses testing`}
            </Text>
          ),
          path: '/testing',
          hide: !userHasBionicChatbots(),
          exact: true,
        },
      ],
    },
  ]
}
